<script setup lang="ts">
import { ref, inject } from 'vue';
import MarketRulesDrawer from './MarketRulesDrawer.vue';
import type { ExchangeConid } from './MarketRulesTable.vue';

const moduleProps = inject<{
  exchangeConids: ExchangeConid[];
}>('moduleProps', {
  exchangeConids: [],
});

const moduleEmit = inject<(event: string, ...args: unknown[]) => void>('moduleEmit', () => {});

const visible = ref(true);

function onVisibilityChange(value: boolean) {
  visible.value = value;
  if (!value) {
    moduleEmit('exit');
  }
}
</script>

<template>
  <ib-application setupSSO>
    <MarketRulesDrawer
      :visible="visible"
      :exchange-conids="moduleProps.exchangeConids"
      :is-module="true"
      @update:visible="onVisibilityChange"
    />
  </ib-application>
</template>
